import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function TechMonoTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-relaxed font-mono overflow-hidden" data-testid="resume-live-preview">
      <div className="p-5" style={{ backgroundColor: "#0f172a" }}>
        <p className="text-emerald-400 text-[11px]">$ whoami</p>
        <h1 className="text-white text-xl font-bold mt-1">{draft.full_name || "your_name"}</h1>
        {draft.target_role && <p className="text-[12px] mt-0.5" style={{ color: accent }}>// {draft.target_role}</p>}
        <p className="text-slate-400 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  ")}</p>
      </div>
      <div className="p-6">
        {draft.summary && (
          <div className="mb-4">
            <p className="text-[11px] font-bold" style={{ color: accent }}># summary</p>
            <p className="text-slate-700 mt-1">{draft.summary}</p>
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <p className="text-[11px] font-bold" style={{ color: accent }}># experience</p>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} @ {e.company} <span className="text-slate-400">[{dateRange(e.start_date, e.end_date, e.current)}]</span></p>
                <ul className="text-slate-600 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>&gt; {b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <p className="text-[11px] font-bold" style={{ color: accent }}># education</p>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1">{ed.degree} {ed.field} — {ed.school}</p>)}
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mb-4">
            <p className="text-[11px] font-bold" style={{ color: accent }}># skills</p>
            <p className="text-slate-700 mt-1">[{draft.skills.join(", ")}]</p>
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
